import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/store/auth'
import { Role } from '@/types/auth'

import BodyView from '@/layouts/BodyView.vue'
const baseRoutes: Array<RouteRecordRaw> = [
  {
    path: '',
    redirect: '/dashboard'
  },
  {
    path: '',
    name: 'home',
    component: BodyView,
    meta: { roles: [] },
    children: [
      {
        path: '/dashboard',
        name: 'mainDashboard',
        component: () => import("@/views/dashboard/MainDashboard.vue"),
        meta: { roles: [] }
      },
      {
        path: '/notifications',
        name: 'notifications',
        component: () => import("@/views/notifications/IndexNotifications.vue"),
        meta: { roles: [] }
      },
      {
        path: "/equipments/:site",
        name: 'dashboardEquipment',
        component: () => import("@/views/dashboard/Equipment.vue"),
        meta: { roles: [] },
      },
      {
        path: "/monitoring/:id",
        name: 'monitoring',
        component: () => import("@/views/monitoring/IndexMonitoring.vue"),
        meta: { roles: [] },
      },
      {
        path: "/monitoringNOV/:id",
        name: 'monitoringNov',
        component: () => import('@/pages/IndexError.vue'),
        meta: { roles: [Role.Administrador, Role.Monitorista] },
      },
      {
        path: "/operational-security/cctv",
        name: 'cctv',
        component: () => import("@/views/operationalSecurity/Cctv.vue"),
        meta: { roles: [] },
      },
      {
        path: "/operational-security/voceo",
        name: 'voceo',
        component: () => import('@/pages/IndexError.vue'),
        meta: { roles: [Role.Administrador, Role.Monitorista, Role.Mantenimiento, Role.Soporte] },
      },
      {
        path: "/operational-security/access-control",
        name: 'accessControl',
        component: () => import('@/pages/IndexError.vue'),
        meta: { roles: [Role.Administrador, Role.Monitorista, Role.Mantenimiento, Role.Soporte] },
      },
      {
        path: "/physical-security/intruder-detector",
        name: 'intruderDetector',
        component: () => import('@/pages/IndexError.vue'),
        meta: { roles: [Role.Administrador, Role.Monitorista, Role.Soporte] },
      },
      {
        path: "/remote-support/activities",
        name: "activities",
        component: () => import("@/views/remoteSupport/activities/IndexActivities.vue"),
        meta: { roles: [Role.Administrador, Role.Monitorista] },
      },
      {
        path: "/remote-support/maintenance",
        name: "maintenance",
        component: () => import("@/views/remoteSupport/maintenance/IndexMaintenance.vue"),
        meta: { roles: [Role.Administrador, Role.Monitorista] },
      },
      {
        path: "/remote-support/alerts",
        name: "alerts",
        component: () => import("@/views/remoteSupport/alerts/IndexAlerts.vue"),
        meta: { roles: [Role.Administrador, Role.Monitorista, Role.Mantenimiento] },
      },
      {
        path: "/remote-support/alerts/:id",
        name: "alert",
        component: () => import("@/views/remoteSupport/alerts/IndexAlerts.vue"),
        meta: { roles: [Role.Administrador, Role.Monitorista, Role.Mantenimiento] },
      },
      {
        path: "/admin/users",
        name: 'users',
        component: () => import("@/views/administration/users/IndexUsers.vue"),
        meta: { roles: [Role.Administrador] },
      },
      {
        path: "/admin/users/create",
        name: 'create-curriculum-vitae',
        component: () => import("@/views/administration/users/FormUsers.vue"),
        meta: { roles: [Role.Administrador] },
      },
      {
        path: "/admin/users/edit/:id",
        name: 'edit-curriculum-vitae',
        component: () => import("@/views/administration/users/FormUsers.vue"),
        meta: { roles: [Role.Administrador] },
      },
      {
        path: "/admin/users/profile/:id",
        name: 'profile',
        component: () => import("@/views/administration/users/Profile.vue"),
        meta: { roles: [Role.Administrador] },
      },
      {
        path: "/admin/users/account/:id",
        name: 'account',
        component: () => import("@/views/administration/users/Account.vue"),
        meta: { roles: [Role.Administrador] },
      },
      {
        path: "/chat/:id/:chatId?",
        name: 'chat',
        // TODO: Add chat view
        component: () => import('@/pages/IndexError.vue'),
        meta: { roles: [Role.Administrador, Role.Monitorista, Role.Mantenimiento] },
      },
      {
        path: "/admin/equipments",
        name: "equipments",
        component: () => import("@/views/administration/equipments/IndexEquipments.vue"),
        meta: { roles: [Role.Administrador] },
      },
      {
        path: "/admin/equipments/create",
        name: 'create-equipment',
        component: () => import("@/views/administration/equipments/FormEquipments.vue"),
        meta: { roles: [Role.Administrador] },
      },
      {
        path: "/admin/equipments/edit/:id",
        name: 'edit-equipment',
        component: () => import("@/views/administration/equipments/FormEquipments.vue"),
        meta: { roles: [Role.Administrador] },
      },
      {
        path: "/admin/variables",
        name: "variables",
        component: () => import("@/views/administration/variables/IndexVariables.vue"),
        meta: { roles: [Role.Administrador] },
      },
      {
        path: "/admin/devices",
        name: 'devices',
        component: () => import("@/views/administration/devices/IndexDevices.vue"),
        meta: { roles: [Role.Administrador] },
      },
      {
        path: "/admin/devices/create",
        name: 'create-device',
        component: () => import("@/views/administration/devices/FormDevices.vue"),
        meta: { roles: [Role.Administrador] },
      },
      {
        path: "/admin/devices/edit/:id",
        name: 'edit-device',
        component: () => import("@/views/administration/devices/FormDevices.vue"),
        meta: { roles: [Role.Administrador] },
      },
      {
        path: "/admin/devices/view/:id",
        name: 'view-device',
        component: () => import("@/views/administration/devices/View.vue"),
        meta: { roles: [Role.Administrador] },
      },
      {
        path: '/forbidden',
        name: 'forbidden',
        component: () => import('@/pages/ForbiddenError.vue'),
      },
      {
        path: '/:pathMatch(.*)*', // Captura todas las rutas no coincidentes
        name: 'NotFound',
        component: () => import('@/pages/IndexError.vue'),
      },
    ]
  },
  {
    path: "/auth/login",
    name: "login",
    component: () => import('@/views/LoginPage.vue'),
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: baseRoutes,
})

router.beforeEach(async to => {
  const authStore = useAuthStore()

  if (typeof (to.meta.title) === 'string') {
    document.title = to.meta.title
  }

  const path = ['/auth/login', '/auth/register']

  if (path.includes(to.path) ) {
    return true
  } else if (authStore.token === '') {
    return { name: 'login', replace: true }
  }

  const jwtPayload = authStore.parseJwt()

  if (jwtPayload.exp < Date.now() / 1000) {
    localStorage.clear()
    authStore.$reset()

    return { name: 'login', replace: true }
  }

  const roles: string[] = to.meta.roles as string[]

  if (authStore.user && roles.length > 0 && !roles.includes(authStore.user.rol)) {
    return { name: 'forbidden', replace: true }
  }
})

export default router
